import React from "react"
import Layout from "../Components/Layout"
import Box from "../Components/Box"

export default () => (
  <Layout>
    <div className="about-page">
      <Box>
        <h1>Privatumo politika</h1>

        <div className="text-container">
          <p>
            VšĮ „Lietuvos nacionalinis radijas ir televizija“ (toliau – LRT), juridinio asmens kodas 124241078, registracijos adresas S. Konarskio g. 49, Vilnius, ir Lietuvos statistikos departamentas (toliau – Statistikos departamentas), įmonės kodas 188600177, registracijos adresas Gedimino pr. 29, 01500 Vilnius, įsipareigoja užtikrinti Jūsų asmens duomenų saugumą ir Jūsų teisių apsaugą Jums naudojantis LRT portalo svetaine www.faktainegandai.lrt.lt (toliau – LRT portalas).
            <br />
            <br />
            Įgyvendindami šias pareigas, LRT ir MO vadovaujasi Bendruoju duomenų
            apsaugos reglamentu, Lietuvos Respublikos asmens duomenų teisinės
            apsaugos įstatymu, Lietuvos Respublikos elektroninių ryšių įstatymu
            ir kitais teisės aktais, reglamentuojančiais asmens duomenų ir
            privatumo teisinę apsaugą.
            <br />
            <br />
            Įgyvendindami šias pareigas, LRT ir Statistikos departamentas vadovaujasi Bendruoju duomenų apsaugos reglamentu, Lietuvos Respublikos asmens duomenų teisinės apsaugos įstatymu, Lietuvos Respublikos elektroninių ryšių įstatymu ir kitais teisės aktais, reglamentuojančiais asmens duomenų ir privatumo teisinę apsaugą.
            <br />
            <br />
            Ši LRT ir Statistikos departamento privatumo politika, slapukų naudojimo tvarka ir taisyklės (toliau – Privatumo politika) aprašo LRT portalo lankytojų duomenų tvarkymo praktiką. Ji gali būti keičiama ir tobulinama pasikeitus galiojančių teisės aktų nuostatoms, esant programinės įrangos funkcionalumo pokyčiams ar kitomis nenumatytomis aplinkybėmis apie pakeitimus bus pranešama LRT portale.
            <br />
            <br />
            Užsukę į LRT portalą, pateikę savo asmens duomenis bei papildomus sutikimus, kai to aiškiai reikia pagal šią Privatumo politiką, Jūs mums suteikiate teisę rinkti, valdyti, tvarkyti ir saugoti Jūsų duomenis tokia apimtimi ir tokiais tikslais, kaip numatyta šioje Privatumo politikoje. Jei naudojatės LRT portalu, vadinasi, Jūs perskaitėte ir sutikote su šia Privatumo politika ir joje nurodytais Jūsų asmens duomenų tvarkymo tikslais, būdais bei tvarka. Jeigu Jūs nesutinkate su Privatumo politika, Jūs neturite teisės naudotis LRT portalu.
            <br />
            <br />
            Ši Privatumo politika netaikoma LRT portale pateikiamoms nuorodoms į trečiųjų šalių tinklalapius, todėl rekomenduojame atskirai pasidomėti šių tinklalapių privatumo politika ar taisyklėmis. <br />

            Šioje Privatumo politikoje Jūs rasite informaciją apie tai: <br/>
            <ul>
              <li>kokius asmens duomenis įgyvendindamas Statistikos egzaminą tvarko LRT ir Statistikos departamentas;</li>
              <li>kokie yra asmens duomenų tvarkymo tikslai;</li>
              <li>kiek laiko LRT ir Statistikos departamentas saugos Jūsų asmens duomenis;</li>
              <li>ar Jūsų asmens duomenys bus perduodama kitiems asmenims;</li>
              <li>kada ir kaip LRT ir Statistikos departamentas gali tvarkyti nepilnamečių asmens duomenis;</li>
              <li>kokius slapukus renka, naudoja ir saugo LRT ir Statistikos departamentas;</li>
              <li>kokias teises Jūs turite ir kaip jas galite įgyvendinti.</li>
            </ul>
            <br />
            <br />
            LRT ir Statistikos departamento tvarkomi Asmens duomenys tvarkomi vadovaujantis vartotojo pateiktu sutikimu. LRT ir Statistikos departamentas tvarko asmens duomenis, kuriuos Jūs patys pateikiate norėdami dalyvauti Statistikos egzamine: vardas, pavardė, elektroninio pašto adresas, amžius.
            <br />
            <br />

            <strong>Asmens duomenų tvarkymo tikslai </strong>
            <br />
            LRT ir Statistikos departamento tvarko jūsų asmens duomenis LRT portale, kad galėtumėte dalyvauti Statistikos egzamine ir jo organizatoriai – Statistikos departamentas bei LRT galėtų susisiekti su dalyviais dėl prizų perdavimo.

            <br />
            <br />
            <strong>Saugojimo terminas</strong>
            <br />
            Jūsų asmens duomenis saugosime ne ilgiau, negu tai būtina šioje Privatumo politikoje nurodytiems tikslams – kol nepasibaigs Statistikos egzaminas ir nebus išdalinti numatyti prizai.
            Asmens duomenys tiesioginės rinkodaros tikslu bus saugomi ne ilgiau kaip 4 mėnesius iki Statistikos egzamino pabaigos.

            <br />
            Ilgiau asmens duomenys gali būti saugoma tik šiais atvejais:
            <br/>
            <ul>
             <li>kai esama pagrįstų įtarimų dėl neteisėtos veikos, dėl kurios yra atliekamas tyrimas;</li>
              <li>kai Jūsų asmens duomenys būtini tam, kad būtų tinkamai išspręstas ginčas ar skundas;</li>
              <li>jeigu mes esame gavę skundų, susijusių su klientu, ar jeigu mes esame pastebėję atitinkamo kliento padarytus pažeidimus;</li>
            <li>esant kitokiam specialiam teisės aktuose numatytiems pagrindui.</li>
            </ul>
            <br />
            <br />
            Šie asmens duomenys sunaikinami nedelsiant gavus teisėtus teisėsaugos ar kitų įgaliotų institucijų nurodymus.
            <br/>
            <br />

            <strong>Asmens duomenų perdavimas</strong>
            <br />
            Jūsų pateikti asmens duomenys jokiu būdu nebus perduodami trečiosioms šalims, išskyrus jei tai būtų būtina mūsų paslaugoms teikti, ir įstatymų numatytus atvejus, kai tai pateikti būtina (pvz., teisėsaugos institucijoms, teismui).
            <br />
            <br />
            Duomenys trečiajai šaliai gali būti perduoti esant išankstiniam Jūsų
            sutikimui.
            <br />
            Asmens duomenų naudojimas tiesioginės rinkodaros tikslais LRT ir Statistikos departamentas gali siųsti Jums informacinius pranešimus elektroniniu paštu apie Statistikos egzaminą, tik jeigu aiškiai nurodėte, kad sutinkate, gauti tokią informaciją.
            <br />
            <br />
            <strong>Nepilnamečių asmens duomenų tvarkymas</strong>

            <br />
            Tvarkant nepilnamečio asmens duomenis sutikimo pagrindu informacinės visuomenės paslaugų siūlymui, toks duomenų tvarkymas yra teisėtas, jei nepilnametis yra sulaukęs bent 14 metų.
            <br />
            <br />
            Jeigu tokiam nepilnamečiui nėra 14 metų, toks tvarkymas yra teisėtas tik tokiu atveju, jei sutikimą davė arba tvarkyti duomenis leido nepilnamečio tėvai arba globėjai, TODĖL: - jeigu Jūs esate jaunesnis nei 14 metų, naudotis LRT portale esančiomis paslaugomis ir turiniu galite tik tuo atveju, jei Jūsų tėvai (globėjai) dėl to yra davę sutikimą LRT ir Statistikos departamentas.
            <br />
            <br />
            <strong>Slapukai</strong> <br />
            LRT portale mes naudojame slapukus (angl. cookies) tik gavę
            išankstinį vartotojo sutikimą, išskyrus būtinuosius slapukus,
            siekdami kiek įmanoma labiau personalizuoti Jūsų lankomo LRT portalo
            veikimą. Slapukais siekiame:
            <ul>
              <li>
                išvengti pakartotinės registracijos ir anketų pildymo
                nuolatiniams portalo lankytojams;
              </li>
              <li>atpažinti sugrįžtančius portalo lankytojus;</li>
              <li>
                analizuoti Jūsų įpročius, kad portalo veikimas būtų patogus,
                efektyvus ir atitiktų Jūsų poreikius bei lūkesčius.
              </li>
            </ul>
            <br />
            <strong>Kas yra slapukai?</strong>
            <br />
            Slapukai yra nedideli tekstiniai failai, kuriuos Jūsų interneto
            naršyklė įdiegia Jūsų kompiuteryje, planšetėje arba išmaniajame
            įrenginyje. Jie leidžia portalui išsaugoti tokius duomenis, kaip
            įrenginio IP adresas, naršyklės tipas, demografinius duomenis
            (amžiaus grupė, lytis), duomenis apie tai, kaip Jūs naudojatės
            portalu (kokius puslapius vartote, kokiu turiniu domitės).
            <br />
            <br />
            Slapukai LRT portalui suteikia „atmintį“ – kiekvieno apsilankymo
            metu Jūs esate atpažįstamas kaip nuolatinis portalo lankytojas.
            <br />
            <br />
            <strong>Kaip slapukai naudojami LRT portale?</strong>
            <br />
            Apsilankius LRT portale, gali būti sukurti tokio tipo slapukai:
            Būtinieji slapukai – slapukai, naudojami vykdant tokias užklausas
            kaip prisijungimas prie vartotojo paskyros.
            <br />
            <br />
            „Google Analytics“ žymėjimo ir elgsenos slapukai – slapukai, kurie
            mums pasako, ar Jūs esate lankęsis LRT portale, ar turite išsaugoję
            ankstesnių apsilankymų slapukus. Šie slapukai leidžia nustatyti
            unikalių LRT portalo lankytojų skaičių ir jų apsilankymo dažnumą.
            Šie slapukai mums padeda rinkti ir sisteminti statistinę
            informaciją; <br /> _autuvc; _atuvs; _gat; – galioja momentiškai;
            <br /> _utma; _ga; _gfp_64b; _atuvc – galioja dvejus metus; <br />
            _utmz – galioja 6 mėnesius; _gid – galioja vieną dieną.
            <br />
            <br />
            Trečiųjų šalių reklaminiai slapukai – daug skelbimų, kuriuos matote
            LRT portale, yra pateikti kitų ūkio subjektų. Kai kurie šie
            subjektai patys naudoja anoniminius slapukus turėdami tikslą žinoti,
            kiek žmonių matė konkretų skelbimą arba kiek žmonių matė jį daugiau
            negu vieną kartą. Tokius slapukus kuriančios bendrovės taiko savo
            parengtas politikas ir mes neturime jokios įtakos tokių slapukų
            kūrimui ar saugojimui. Mes Jums rekomenduojame atskirai pasidomėti
            tų bendrovių privatumo ar slapukų politika, kuri paprastai būna
            paskelbta jų interneto tinklalapyje.
            <br />
            <br />
            Kiti trečiųjų šalių slapukai – kai kuriuose LRT portalo puslapiuose
            kiti subjektai taip pat gali naudoti savo pačių anoniminius
            slapukus, skirtus tam, kad jų sukurtos programos ar programėlės būtų
            pritaikytos Jūsų poreikiams. Dėl slapukų veikimo specifikos LRT
            portalas neturi prieigos prie šių slapukų, lygiai kaip ir kiti
            subjektai neturi prieigos prie mūsų nustatomų slapukų.
            <br />
            <br />
            <strong>
              Kaip išjungti slapukus ir nebesutikti su jų rinkimu?
            </strong>
            <br />
            Daugelis interneto naršyklių yra nustatytos taip, kad automatiškai
            priimtų slapukus. Bet kuriuo Jums patogiu metu slapukus galite
            išjungti ir tokiu būdu nebesutikti, kad LRT portalas juos rinktų,
            tačiau taip padarius bus sumažintas portalo funkcionalumas, todėl
            jis gali neveikti taip, kaip dera, ir kaip veikė iki tokio
            atsisakymo.
            <br />
            <br />
            Visos šiuolaikinės interneto naršyklės leidžia keisti slapukų
            nustatymus. Paprastai šiuos nustatymus galite rasti savo naršyklės
            parinkčių arba pasirinkimų (angl. Settings, Internet Options ir
            pan.) meniu:
            <br />
            <a
              rel="noopener noreferrer"
              href="https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage-cookies#ie=ie-10"
              target="_blank"
            >
              Slapukų nustatymai
            </a>{" "}
            Internet Explorer <br />
            <a
              rel="noopener noreferrer"
              href="https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer?redirectlocale=en-US&redirectslug=Cookies"
              target="_blank"
            >
              Slapukų nustatymai
            </a>{" "}
            Firefox
            <br />
            <a
              rel="noopener noreferrer"
              href="https://support.google.com/chrome/answer/95647?hl=en&ref_topic=14666"
              target="_blank"
            >
              Slapukų nustatymai
            </a>{" "}
            Chrome
            <br />
            <a
              rel="noopener noreferrer"
              href="https://support.apple.com/it-it/guide/safari/sfri11471/mac"
              target="_blank"
            >
              Slapukų nustatymai
            </a>{" "}
            Safari web ir iOS.
            <br />
            <br />
            <br />
            Kad suprastumėte šiuos nustatymus, Jums gali padėti pateiktos
            nuorodos, arba galite pasinaudoti savo naršyklės pagalbos (angl.
            Help) pasirinkimu.
            <br />
            <br />
            <strong>Jūsų teisės</strong>
            <br />
            Vadovaujantis asmens duomenų apsaugą reglamentuojančiais teisės
            aktais, Jūs turite šias teises: <br />
            <ul>
              <li>
                Vadovaujantis asmens duomenų apsaugą reglamentuojančiais teisės aktais, Jūs turite šias teises:
                sužinoti (būti informuotu), kokius Jūsų asmens duomenis tvarko LRT ir Statistikos departamentas;

              </li>
              <li>
                susipažinti su savo asmens duomenimis, kuriuos mes tvarkome;
              </li>
              <li>
                reikalauti ištaisyti neteisingus, netikslius savo asmens
                duomenis;
              </li>
              <li>
                reikalauti ištrinti visus apie Jus sukauptus duomenis, kai jie
                daugiau nereikalingi tikslams, kuriems buvo surinkti;
              </li>
              <li>
                reikalauti sunaikinti asmens duomenis, jei jie tvarkomi
                neteisėtai;
              </li>
              <li>
                reikalauti apriboti duomenų tvarkymą, jei tai atitinka įstatymu
                apibrėžtus kriterijus;
              </li>
              <li>nesutikti su Jūsų asmens duomenų tvarkymu;</li>
              <li>
                atšaukti duotą sutikimą tiesioginei rinkodarai ar slapukams.
              </li>
            </ul>
            <br />
            Gavę tokį Jūsų prašymą ar nurodymą, mes ne vėliau kaip per 30
            (trisdešimt) kalendorinių dienų pateiksime atsakymą apie atliktus
            prašyme nurodytus veiksmus ar motyvuotai atsisakysime juos atlikti.
            <br />
            <br />
            Jums pateikus prašymą, susijusį su aukščiau nurodytų teisių
            įgyvendinimu, mums gali būti reikalinga nustatyti Jūsų asmens
            tapatybę dėl ko mes galime paprašyti Jūsų pateikti papildomų duomenų
            ar dokumentų. Visi šie papildomi duomenys bus naudojami išimtinai
            tik Jūsų tapatybės nustatymo tikslais ir tai padarius bus nedelsiant
            saugiai mūsų ištrinti.
            <br />
            <br />
            Jūsų prašymas, klausimas ar nurodymas LRT turi būti pateikiamas
            vienu iš šių būdų:
            <ul>
              <li>
                registruotu paštu siunčiant adresu S. Konarskio g. 49, Vilnius;
              </li>
              <li>
                elektroniniu paštu adresu{" "}
                <a href="mailto:lrt@lrt.lt" title="lrt@lrt.lt">
                  lrt@lrt.lt
                </a>
                .
              </li>
            </ul>
            <br />
            Gindami savo pažeistas teises, susijusias su asmens duomenų teisine
            apsauga, Jūs turite teisę pateikti skundą Valstybinei duomenų
            apsaugos inspekcijai (
            <a
              href="https://www.ada.lt"
              rel="noopener noreferrer"
              title="www.ada.lt"
              target="_blank"
            >
              www.ada.lt
            </a>
            ).
          </p>
        </div>
      </Box>
    </div>
  </Layout>
)
